import AvaliacaoService from '../../services/AvaliacaoService'
import router from '../../router'

const state = () => ({
    loadingAvaliacao: false,
    avaliacao: null,
    avaliacoes: [],
    newAvaliacao:{
        description: '',
    },
    total: 0,
    pages: 0,
    page: 1,
    questaoIndex: 0,
    respostas: (() => {
        try {
            return JSON.parse(localStorage.getItem('avaliacao_respostas')) || {};
        } catch (e) {
            localStorage.removeItem('avaliacao_respostas');
            return {};
        }
    })(),
})
  
const mutations = {
    SET_AVALIACAO: (state, payload) => {
        state.avaliacao =  payload
    },
    SET_AVALIACOES: (state, payload) => {
        if(payload.pageNumber == 1) {
            state.avaliacoes = payload.itens
        }else{
            state.avaliacoes = [...state.avaliacoes, ...payload.itens]
        }
        state.page =  payload.pageNumber
        state.pages =  payload.pages
        state.total =  payload.total
    },
    SET_LOADING_AVALIACAO: (state, payload) => {
        state.loadingAvaliacao = payload
    },
    SET_INDEX_QUESTION: (state, payload) => {
        state.questaoIndex = payload
    },
    SET_RESPOSTA: (state, { idAvaliacao, idQuestao, idResposta }) => {
        if (!state.respostas[idAvaliacao]) {
            state.respostas[idAvaliacao] = {};
        }
        state.respostas[idAvaliacao][idQuestao] = idResposta;
        localStorage.setItem('avaliacao_respostas', JSON.stringify(state.respostas));
    },
}

const actions = {
    async fetchAvaliacoes({commit}, params = {}){
        try{
            commit('SET_LOADING_AVALIACAO', true)
            const { keyword = '', pageNumber = 1, pageSize = 12, order = { name: 'ID', column: 'ID', sort: 'ASC' }, idDisciplina = null, idAula = null } = params;
            const response = await AvaliacaoService.get(keyword, pageNumber, pageSize, order, idDisciplina, idAula);
            commit('SET_AVALIACOES', response.data)
            commit('SET_LOADING_AVALIACAO', false)
        } catch (error) {
            commit('SET_LOADING_AVALIACAO', false);
            if(error && error.response && error.response.data.message == "Sessão expirada") {
                commit('SET_REDIRECT', router.currentRoute.value.path);
            }
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async fetchAvaliacao({commit}, id){
        try{
            commit('SET_LOADING_AVALIACAO', true)
            const response = await AvaliacaoService.getOne(id);
            commit('SET_AVALIACAO', response.data)
            commit('SET_LOADING_AVALIACAO', false)
        } catch (error) {
            commit('SET_LOADING_AVALIACAO', false);
            router.push({path: `/avaliacoes`});
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async submitAvaliacao({ commit }, { idAvaliacao = 1, formDataObject = null }) {
        try{
            commit('SET_LOADING_AVALIACAO', true)
            const body = {
                idAvaliacao,
                respostas: formDataObject
            }
            const response = await AvaliacaoService.add_respostas(body);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            setTimeout(() => {
                commit('SET_AVALIACAO', null)
                window.location.reload();
            }, 3000);
            commit('SET_LOADING_AVALIACAO', false)
        } catch (error) {
            commit('SET_LOADING_AVALIACAO', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async updadeAvaliacao({commit}, data){
        try{
            commit('SET_LOADING_AVALIACAO', true)
            const response = await AvaliacaoService.update(data);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            commit('SET_LOADING_AVALIACAO', false)
        } catch (error) {
            commit('SET_LOADING_AVALIACAO', false);
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
}

const getters = {
    getAvaliacao: state => state.avaliacao,
    getAvaliacoes: state => state.avaliacoes,
    getLoadingAvaliacao: state => state.loadingAvaliacao,
    getIndexQuestion: state => state.questaoIndex,
    getRespostas: state => state.respostas,
}

export default {
    state,
    getters,
    mutations,
    actions
};